import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import Loader from "./components/Loader";
import "./index.scss";
import Router from "./Router";
import { PersistGate } from "redux-persist/lib/integration/react";

// import the two exports from the last code snippet.
import { persistor, store } from "./store";
import { verifyTenent, onCheckAutherizationToken, getTenantGUID } from "./Tenants";
import { webUrlAccess } from "./common/constants";
import { BrandingProvider } from "./branding/BrandingContextProvider";

if (
  window.location.protocol === "http:" &&
  !window.location.hostname.includes("app.localhost")
) {
  window.location.href = window.location.href.replace("http:", "https:");
}

const tenantId = getTenantGUID(webUrlAccess);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <BrandingProvider tenantId={tenantId}>
        <Router />
      </BrandingProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

onCheckAutherizationToken();
verifyTenent(webUrlAccess);
